module.exports = "<h2>Obras</h2>\r\n<p-chart type=\"pie\" [data]=\"data\"></p-chart>\r\n"